module.exports = __webpack_public_path__ + "static/apple-icon-180x180-c93aeb0a46e324bc9086d13e53b7134c.png";